import { Vector3 } from "../System.Numerics.Vector3.gen";
import { read_f32, read_u32, Sink } from "../../helpers/serializerHelpers";

export class TrackState {
    public trackId: number = 0;

    public positionX: number = 0; //Meters
    public positionY: number = 0;
    public positionZ: number = 0;

    public velocityX: number = 0; //Meters/s
    public velocityY: number = 0;
    public velocityZ: number = 0;

    public accelerationX: number = 0; //Meters/second/second
    public accelerationY: number = 0;
    public accelerationZ: number = 0;

    public ecBytes: Number[] = new Array<Number>(16);//Target Error covariance matrix, [4x4 float], in row major order, range, azimuth, elev, doppler

    public g: number = 0; //Gating function gain
    public confidence: number = 0; //confidence

    public position() {
        return new Vector3({ x: this.positionX, y: this.positionY, z: this.positionZ });
    }

    public velocity() {
        return new Vector3({ x: this.velocityX, y: this.velocityY, z: this.velocityZ });
    }

    public acceleration() {
        return new Vector3({ x: this.accelerationX, y: this.accelerationY, z: this.accelerationZ });
    }

    public toString() {
        return `Target ${this.trackId}, Position ${this.positionX}, ${this.positionY}`;
    }
    public deserialize(bytes: Sink) {
        this.trackId = read_u32(bytes);

        this.positionX = read_f32(bytes); //Meters
        this.positionY = read_f32(bytes);
        this.positionZ = read_f32(bytes);

        this.velocityX = read_f32(bytes); //Meters/s
        this.velocityY = read_f32(bytes);
        this.velocityZ = read_f32(bytes);

        this.accelerationX = read_f32(bytes); //Meters/second/second
        this.accelerationY = read_f32(bytes);
        this.accelerationZ = read_f32(bytes);

        this.ecBytes = new Array<Number>(16);
        for (var i = 0; i < 16; i++) {
            this.ecBytes[i] = read_f32(bytes);
        }

        this.g = read_f32(bytes); //Gating function gain
        this.confidence = read_f32(bytes); //confidence

        return this;
    }
    public getLength() {
        return 28 * 4;
    }
}
